import { useState, useMemo } from 'react';
export function usePaginator(items, {
  itemsPerPage,
  defaultPage = 1
}) {
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const pageCount = useMemo(() => Math.ceil(items.length / itemsPerPage), [items.length, itemsPerPage]);
  const paginatedItems = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return items.slice(startIndex, endIndex);
  }, [items, currentPage, itemsPerPage]);
  return useMemo(() => ({
    currentPage,
    pageCount,
    paginatedItems,
    setPage: setCurrentPage
  }), [currentPage, pageCount, paginatedItems]);
}